import { createContext, useContext } from 'react';

const DndCardContext = createContext({ visible: true, inDndCard: false });

export const DndCardProvider = DndCardContext.Provider;

export const useDndCardContext = () => useContext(DndCardContext);

export default DndCardContext;
